import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

const MyFormattedCurrency = ({ value }) => (value !== null && value !== undefined
  ? (
    <FormattedNumber
      value={value}
      currency="IDR"
      // eslint-disable-next-line react/style-prop-object
      style="currency"
    />
  ) : '');


MyFormattedCurrency.propTypes = {
  value: PropTypes.number.isRequired,
};

MyFormattedCurrency.defaultProps = {

};

export default MyFormattedCurrency;
